import React, { useState } from 'react'
import { LinkProps } from 'react-router-dom'

import { Link } from '../../../navigation/custom-react-router-dom'
import { useWindowResize } from '../../../utils/domUtils'
import { TextLargeStrong, TextSmall } from '../../Typography/Typography'
import { Bubble, BubbleProps } from '../Bubble/Bubble'
import { InfoCardModal } from './InfoCardModal'
import { useInfoCardMove } from './useInfoCardMove'

import styles from './InfoCard.module.scss'

export interface InfoCardProps extends BubbleProps {
  title?: string
  text?: React.ReactNode
  render?: React.ReactNode
  link?: InfoCardLinkProps
  lockDirection?: boolean

  className?: string
  modalCardClassName?: string

  /** @deprecated rarely used, for hacky workarounds  */
  cardStyle?: React.CSSProperties
}

export interface InfoCardLinkProps {
  to: LinkProps['to']
  state?: LinkProps['state']
  text: string
  target?: LinkProps['target']
}

export const InfoCard: React.FC<InfoCardProps> = (props) => {
  const isMobile = useWindowResize()
  return isMobile ? <InfoCardMobile {...props} /> : <InfoCardDesktop {...props} />
}

const InfoCardDesktop: React.FC<InfoCardProps> = (props) => {
  const { title, direction, lockDirection } = props
  const { children, cardStyle } = props

  const { boxRef, newDirection } = useInfoCardMove(direction)

  const handleClick = (event: React.MouseEvent) => {
    event.stopPropagation()
    event.preventDefault()
  }

  return (
    <Bubble
      {...{ ...props, direction: lockDirection ? direction : newDirection }}
      component={children}
    >
      <div className={styles.infoCard} style={cardStyle} ref={boxRef} onClick={handleClick}>
        {title && <TextLargeStrong className={styles.title}>{title}</TextLargeStrong>}
        <InfoCardContent {...props} />
      </div>
    </Bubble>
  )
}

export const InfoCardMobile: React.FC<InfoCardProps> = (props) => {
  const { title, disabled } = props
  const { children } = props

  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleModalOpen = (event: React.PointerEvent<HTMLDivElement>) => {
    event.stopPropagation()
    event.preventDefault()
    setIsModalOpen(true)
  }

  const handleModalClose = () => {
    setIsModalOpen(false)
  }

  return (
    <div onPointerDown={handleModalOpen}>
      {isModalOpen && !disabled && (
        <InfoCardModal title={title} onClose={handleModalClose}>
          <InfoCardContent {...props} />
        </InfoCardModal>
      )}
      {children}
    </div>
  )
}

const InfoCardContent: React.FC<InfoCardProps> = (props) => {
  const { text, render, link } = props

  return (
    <>
      <TextSmall>{text}</TextSmall>
      {render && <div>{render}</div>}
      {link && (
        <Link
          to={link.to}
          target={link.target || '_blank'}
          state={link.state}
          onClick={(e) => e.stopPropagation()}
        >
          {link.text}
        </Link>
      )}
    </>
  )
}
